export const getSocketUrl = () => {
  const configuredApiUrl = import.meta.env.VITE_API_URL;
  if (configuredApiUrl) {
    return configuredApiUrl.replace(/\/api\/?$/, '');
  }

  return window.location.hostname === 'localhost' ? 'http://localhost:5000' : '';
};
